import React, { useEffect, useState } from "react";
import { Modal, Button, Box, Backdrop, CircularProgress } from "@mui/material";
import { useForm } from "react-hook-form";
import "./index.scss";
import {
  loadCaptchaEnginge,
  LoadCanvasTemplate,
  // LoadCanvasTemplateNoReload,
  validateCaptcha,
} from "react-simple-captcha";
import uploadimg from "../../../../images/Icon/file-upload.svg";
import { PostCallApi } from "../../../../Action/Action";
import { SwalError, SwalSuccess } from "../../../../components/SwalToast";
import { getSupportCategories, getSupportDistricts, createTicket } from "../../../../Modules/User/Help/supportLookups";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  // height: "50%",
  width: "60%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  outline: 0,
};
function HelpBox(props) {
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();
  const [derror, setDerror] = useState();
  const [openCircle, setOpenCircle] = useState(false);

  const [openEdit, setOpenEdit] = useState(false);
  const [supportCategories, setSupportCategories] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const handlePop = () => {
    setOpenEdit(true);
    props.test();
  };
  const handleClose = () => {
    setOpenEdit(false);
    setDerror();
    reset();
    props.test();
  };
  useEffect(() => {
    if (openEdit) {
      setTimeout(function () {
        loadCaptchaEnginge(6, "black", "white");
        setValue("Priority", "Medium");
        setValue("SupportCategoryId", 1);
      }, 500);
      getSupportCategories().then(setSupportCategories);
      getSupportDistricts().then(setDistrictList);
    }
    // eslint-disable-next-line
  }, [openEdit]);
  const onSubmit = async (data) => {
    if (validateCaptcha(data?.captcha, false) === true) {
      loadCaptchaEnginge(6, "black", "white");
      let tdata = {
        ...data,
        IsSentByFigSupport: false,
        IsWithOutLogin: true,
        Status: "created",
      };
      setDerror({ h_er: "" });
      setOpenCircle(true);

      // Same support route as the signed-in form. This used to post to the .NET
      // endpoint, which is hardcoded to production — so a ticket raised from the login
      // page on figdev was written to the LIVE database while the ticket list read dev,
      // and never appeared anywhere it could be worked.
      const created = await createTicket({
        email: data?.Email,
        userName: data?.UserName,
        phone: data?.Phone,
        priority: data?.Priority,
        supportCategoryId: data?.SupportCategoryId,
        subject: data?.Subject,
        description: data?.Description,
        // Sent as a real id now that the field is a picker rather than free text.
        schoolDistrictId: data?.SchoolDistrictId,
        isWithOutLogin: true,
      });

      setOpenCircle(false);
      if (created?.success) {
        handleClose();
        SwalSuccess(created?.message || "Ticket created");
      } else {
        SwalError(created?.message || "Something went wrong, please try again.");
      }
    } else {
      setDerror({ h_er: "Captcha does not match." });
    }
  };

  const handleImg = (e) => {
    setValue("FilePath", e.target.files[0]);
    setValue("imgUpload", e.target.files[0].name);
    e.target.files = null;
  };
  return (
    <>
      {" "}
      <Button onClick={handlePop} className="help_btn">
        {/* <img src={information} alt="" /> */}
        Need Help ? Contact Support
      </Button>
      {openEdit && (
        <Modal
          open={openEdit}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="popup_help_box"
        >
          <Box sx={style} className={`main_box `}>
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={openCircle}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
            <form onSubmit={handleSubmit(onSubmit)} className="detail_submit">
              <h3 className="text-center mb-4">Create a Support Ticket</h3>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="form-label">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter your name"
                      {...register("UserName", {
                        required: "This field is required",
                        pattern: {
                          value: /[A-Za-z]{3}/,
                          message: "Enter only Alphabets",
                        },
                      })}
                    />
                    {errors.UserName && (
                      <span role="alert" className="error_text">
                        {errors.UserName.message}
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="form-label">Email</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter email"
                      {...register("Email", {
                        required: "This field is required",
                        pattern: {
                          value: /\S+@\S+\.\S+/,
                          message: "Please Enter Valid Email",
                        },
                      })}
                    />
                    {errors.Email && (
                      <span role="alert" className="error_text">
                        {errors.Email.message}
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="form-label">Phone</label>
                    <input
                      type="text"
                      className="form-control "
                      placeholder="Enter Phone"
                      {...register("Phone", {
                        required: "This field is required",
                        pattern: {
                          value:
                            /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
                          message: "Enter valid phone number",
                        },
                      })}
                    />
                    {errors.Phone && (
                      <span role="alert" className="error_text">
                        {errors.Phone.message}
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="form-label">Priority</label>
                    <select
                      name=""
                      className="form-select"
                      {...register("Priority", {
                        required: "This field is required",
                      })}
                    >
                      <option value="">Select Priority</option>
                      <option value="High">High</option>
                      <option value="Low">Low</option>
                      <option value="Medium">Medium</option>
                    </select>
                    {errors.Priority && (
                      <span role="alert" className="error_text">
                        {errors.Priority.message}
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="form-label">Category</label>
                    <select
                      name=""
                      className="form-select"
                      {...register("SupportCategoryId", {
                        required: "This field is required",
                        valueAsNumber: true,
                      })}
                    >
                      {/* Loaded from SupportCategory rather than hardcoded, so the list
                          can't drift from the table again — "Feature Request" was in the
                          data but unpickable here. */}
                      <option value="">Select Category</option>
                      {supportCategories.map((c) => (
                        <option key={c.id} value={c.id}>{c.name}</option>
                      ))}
                    </select>
                    {errors.SupportCategoryId && (
                      <span role="alert" className="error_text">
                        {errors.SupportCategoryId.message}
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="form-label">Subject</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter subject"
                      {...register("Subject", {
                        required: "This field is required",
                      })}
                    />
                    {errors.Subject && (
                      <span role="alert" className="error_text">
                        {errors.Subject.message}
                      </span>
                    )}
                  </div>
                </div>
                <div className=" col-md-6">
                  <div className="form-group">
                    <label className="form-label">Upload Attachment</label>
                    <div className="upload_img">
                      <input
                        type="text"
                        className="form-control upload_box"
                        placeholder="No file Chosen"
                        readOnly
                        {...register("imgUpload", {
                          // required: "This field is required",
                        })}
                      />
                      <input
                        type="file"
                        id="attch_tic"
                        // accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        // accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        className="form-control"
                        style={{ display: "none" }}
                        placeholder="User You Want To Be In District"
                        onChange={handleImg}
                      />
                      <label
                        htmlFor="attch_tic"
                        className="upload_img_label mb-0 "
                      >
                        <img src={uploadimg} className="img-fluid" alt="" />
                      </label>
                    </div>
                    {errors?.imgUpload && (
                      <span role="alert" className="error_text">
                        {errors.imgUpload.message}
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="form-label">School District</label>
                    {/* Was a free-text box. The backend resolved it with
                        DistrictName.Contains(), so a typo recorded no district at all
                        (44% of tickets) and a partial name could match the wrong one —
                        "Monroe County School" is a substring of "Monroe County Schools
                        (FL)". Picking from the real list sends the actual id. */}
                    <select
                      className="form-select"
                      {...register("SchoolDistrictName", {
                        required: "This field is required",
                      })}
                      onChange={(e) => {
                        const name = e.target.value;
                        setValue("SchoolDistrictName", name);
                        const match = districtList.find((d) => d.name === name);
                        setValue("SchoolDistrictId", match ? match.id : "");
                      }}
                    >
                      <option value="">
                        {districtList.length ? "Select your district" : "Loading districts…"}
                      </option>
                      {districtList.map((d) => (
                        <option key={d.id} value={d.name}>{d.name}</option>
                      ))}
                    </select>
                    {/* Registered so the resolved id is actually part of the submitted
                        payload — setValue alone on an unregistered field wouldn't be. */}
                    <input type="hidden" {...register("SchoolDistrictId")} />
                    {errors.SchoolDistrictName && (
                      <span role="alert" className="error_text">
                        {errors.SchoolDistrictName.message}
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="form-label">Description</label>
                    <textarea
                      rows={5}
                      type="text"
                      className="form-control"
                      placeholder="Enter description"
                      {...register("Description", {
                        required: "This field is required",
                      })}
                    />
                    {errors?.Description && (
                      <span role="alert" className="error_text">
                        {errors.Description.message}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className="form-group mb-3">
                <div className="d-flex">
                  <div className="w-50 mt-auto me-3 captcha_box ">
                    <LoadCanvasTemplate />
                  </div>
                  <div className="w-50">
                    <label className="form-label">Captcha</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Captcha"
                      {...register("captcha", {
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                        maxLength: {
                          value: 6,
                          message: "Max 6 characters",
                        },
                      })}
                    />
                    {errors?.captcha && (
                      <span role="alert" className="d-block error_text">
                        {errors.captcha.message}
                      </span>
                    )}
                    {derror?.h_er && (
                      <span role="alert" className="d-block error_text">
                        {derror.h_er}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className="form-group">
                <Button className="submit" type="submit">
                  Submit
                </Button>
                <Button className="cancel" onClick={handleClose}>
                  Cancel
                </Button>
              </div>
            </form>
          </Box>
        </Modal>
      )}
    </>
  );
}

export default HelpBox;
